export async function affShipmentsScannUseCase(transaction_id, identifier, shipmentRepository) {
    const result = await shipmentRepository.aff_scan_identifier(transaction_id, identifier);
    
    const entity = new shipmentRepository.model_aff_scanned(result.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("Shipments Aff Prepare Inválido");
    }
    
    return result;
}